<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Informe de Recibidos</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../assets/parcels.png">
    <div class="content">Informe de Recibidos</div>
  </h1>
  <div v-if="!apmOptions" class="ui active centered inline loader"></div>
  <div v-if="apmOptions" class="ui stackable ">
    <div class="row">
      <form class="ui form" @submit.prevent="getReceivedParcels">
        <h4 class="ui dividing header">Paquetes recogidos entre fechas seleccionadas</h4>
        <div class="four fields">
          <div class="field">
            <label>Taquilla</label>
            <sui-dropdown class="altuera" :options="apmOptions" placeholder="Taquilla" selection v-model="place_id" />
          </div>
          <div class="field">
            <label>Fecha Inicio</label>
            <datepicker v-model="dateStart" name="dateStart" :language="es"></datepicker>
          </div>
          <div class="field">
            <label>Fecha Final</label>
            <datepicker v-model="dateEnd" name="dateEnd" :language="es"></datepicker>
          </div>
          <div class="field">
            <label> &nbsp;</label>
            <button class="ui button fluid" type="submit">OK</button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="finding" class="ui active centered inline loader"></div>
    <div v-if="receivedParcelList" class="row">
      <div  class="ui black fluid button" v-on:click="exportToCSV()">EXPORTAR DATOS</div>
      <h4 class="ui dividing header">Paquetes recogidos</h4>
      <table class="ui compact selectable table">
        <thead>
          <tr>
            <th>Barcode/Nº Pedido</th>
            <th v-if="isLeroy">Nº Tienda</th>
            <th v-else>Referencia</th>
            <th>Nombre</th>
            <th>Telefono</th>
            <th>Tamaño</th>
            <th>Fecha de Creación</th>
            <th>Fecha de Introducción</th>
            <th>Fecha de Recogida</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in receivedParcelList" v-bind:key="data.id">
            <td v-if="!data.multiorder_code">{{data.barcode}}</td>
            <td v-if="data.multiorder_code">{{data.multiorder_code}}</td>
            <td>{{data.refcode}}</td>
            <td>{{data.name}}</td>
            <td>{{data.phone}}</td>
            <td>{{data.pack_size}}</td>
            <td>{{data.created}}</td>
            <td>{{data.in_apt_date}}</td>
            <td>{{data.lastUpdate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>
<script>
import {
  es
} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'receivedReport',
  data() {
    return {
      receivedParcelList: null,
      place_id: null,
      apmOptions: null,
      es: es,
      dateStart: null,
      dateEnd: null,
      isLeroy: false,
      finding: false
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    this.isLeroy = (JSON.parse(localStorage.company).name === 'Leroy Merlin') ? true : false;
    if (role === 'master' || role.includes('apiclient') || role.includes('staffappmediamarkt') || role.includes('clientApi')) {
      this.getUsersApms()
      this.dateStart = new Date()
      this.dateEnd = new Date()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    getUsersApms() {
      let _this = this
      hapiickApi().post('/v1/users/apms', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(function(req) {
        let apmsList = JSON.parse(JSON.stringify(req.data.data.apms))
        let resultApm = []
        for (let i = 0; i < apmsList.length; i++) {
          resultApm.push({
            key: apmsList[i].Apt.place_id,
            text: apmsList[i].LanguagesApts[0].name,
            value: apmsList[i].Apt.place_id
          })
        }
        setTimeout(function() {
          _this.apmOptions = resultApm;
          _this.place_id = resultApm[0].key
        }, 1000)

      })
      .catch(() => console.log('error getting apms'))
    },
    getReceivedParcels() {
      this.finding = true;
      this.receivedParcelList = null;
      hapiickApi().post('/v4/shipments/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: {
          'apm': this.place_id,
          'status': 'delivered',
          'startDate': this.dateStart,
          'endDate': this.dateEnd
        }
      })
      .then(request => {
        this.updateTable(request)
        this.finding = false;
      })
      .catch((request) => console.log('error getting parcels:' + request))
    },
    updateTable(req) {
      this.receivedParcelList = req.data.data.parcels
    },
    exportToCSV() {
      let filename='receivedParcels.csv'
      var csv = [];
      var rows = document.querySelectorAll("table tr");
      for (var i = 0; i < rows.length; i++) {
        var row = [],
          cols = rows[i].querySelectorAll("td, th");
        for (var j = 0; j < cols.length; j++) {
          row.push(cols[j].innerText);
        }
        csv.push(row.join(","));
      }

      // download csv file
      this.downloadCSV(csv.join("\n"), filename);
    },
    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;

      if (window.Blob == undefined || window.URL == undefined || window.URL.createObjectURL == undefined) {
        alert("Your browser doesn't support Blobs");
        return;
      }

      csvFile = new Blob([csv], {
        type: "text/csv"
      });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  },
  components: {
    Datepicker
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ReceivedReport.vue